import OtsTableGroupNew from './OtsTableGroupNew'

OtsTableGroupNew.install = Vue => {
    Vue.component(OtsTableGroupNew.name,OtsTableGroupNew)
}

export default OtsTableGroupNew